import { NavLink } from 'react-router-dom'
import KeycloakService from '../../../utils/keycloakService'
import {
  DIAGNOSIS_READ,
  DIAGNOSIS_WRITE,
  HISTORY_READ,
  HISTORY_WRITE,
  LAB_ORDERS_READ,
  LAB_ORDERS_WRITE,
  MEDICATIONS_READ,
  MEDICATIONS_WRITE,
  SYSTEMIC_READ,
  SYSTEMIC_WRITE,
  VITALS_READ,
  VITALS_WRITE,
} from '../../../utils/roles'
import { useAppSelector } from '../../../app/hooks'
import { selectPatientData } from '../OpdPatientSlice'

type OpdMenuProps = {
  isCampmenu?: boolean
}

const OpdMenu: React.FC<OpdMenuProps> = ({ isCampmenu }) => {
  const visit = useAppSelector(selectPatientData)

  const menuItems = [
    {
      to: 'history',
      label: 'History & Examination',
      roles: [HISTORY_READ, HISTORY_WRITE],
    },
    {
      to: 'campPatientVitals',
      label: 'Camp Vitals',
      show: isCampmenu === true,
    },
    {
      to: 'vitals',
      label: 'Vitals',
      roles: [VITALS_READ, VITALS_WRITE],
      show: !isCampmenu,
    },
    {
      to: 'systemic',
      label: 'Systemic Examination',
      roles: [SYSTEMIC_READ, SYSTEMIC_WRITE],
    },
    {
      to: 'diagnosis',
      label: 'Diagnosis',
      roles: [DIAGNOSIS_READ, DIAGNOSIS_WRITE],
    },
    {
      to: 'treatmentPhysio',
      label: 'Treatment Plan',
      roles: [MEDICATIONS_READ, MEDICATIONS_WRITE],
    },
    {
      to: 'medications',
      label: 'Medications',
      roles: [MEDICATIONS_READ, MEDICATIONS_WRITE],
    },
    {
      to: 'lab-orders',
      label: 'Lab Orders',
      roles: [LAB_ORDERS_READ, LAB_ORDERS_WRITE],
      show: !isCampmenu,
    },
    {
      to: 'radiology-orders',
      label: 'Radiology Orders',
      roles: [LAB_ORDERS_READ, LAB_ORDERS_WRITE],
      show: !isCampmenu,
    },
    {
      to: 'devices',
      label: 'Devices',
      roles: [VITALS_READ, VITALS_WRITE],
      show: isCampmenu
        ? visit?.speciality === 'General Medicine'
          ? true
          : false
        : true,
    },
    {
      to: 'cancerScreening',
      label: 'Cancer Screening',
      show: visit?.visitType === 'cancerscreening',
    },
    {
      to: 'dentalclinicalcxamination',
      label: 'Dental Clinical Examination',
      show: isCampmenu === true && visit?.speciality === 'DENTAL',
    },
    {
      to: 'chiefComplaints',
      label: 'Chief Complaints',
      show: isCampmenu === true,
    },
    {
      to: 'pastMedicalHistory',
      label: 'Past Medical History',
      show: isCampmenu === true,
    },
    {
      to: 'doctorReview',
      label: 'Doctor Review',
      show: isCampmenu === true,
    },
    {
      to: 'entscreening',
      label: 'Ent Screening',
      show: isCampmenu === true && visit?.speciality === 'ENT',
    },
    {
      to: 'opthmologyScreening',
      label: 'Opthmology Screening',
      show: isCampmenu === true && visit?.speciality === 'Ophthalmology',
    },
    {
      to: 'healthgrading',
      label: 'Health Grading',
      show: isCampmenu === true && visit?.speciality === 'General Medicine',
    },
  ]

  const shouldShowItem = (item: any) => {
    if (item?.show !== undefined) return item?.show
    if (item?.roles) return KeycloakService?.hasRole(item?.roles)
    return true
  }

  return (
    <div className='opd-menu'>
      <ul>
        {menuItems?.map(
          (item) =>
            shouldShowItem(item) && (
              <li key={item?.to}>
                <NavLink to={item?.to}>{item?.label}</NavLink>
              </li>
            )
        )}
        {/* {isCampmenu === true && (
          <li>
            <NavLink to='documentUpload'>Other Services</NavLink>
          </li>
        )} */}
      </ul>
    </div>
  )
}
export default OpdMenu
